import { all, call, put, takeLatest } from "redux-saga/effects";
import * as epgActions from "./action";
import {
  addEpgChannel,
  deleteEpgChannel,
  FetchEpgChangeLog,
  FetchEpgList,
  updateEpgListItem,
} from "./services";

export function* fetchEpgListSaga(action) {
  try {
    const response = yield call(FetchEpgList, action.payload);
    if (response?.data?.success) {
      yield put(epgActions.FetchEpgListSuccess(response?.data?.data));
    } else {
      yield put(epgActions.FetchEpgListFailed(response?.data?.message));
    }
  } catch (error) {
    yield put(epgActions.FetchEpgListFailed(error));
  }
}

export function* fetchMoreEpgListSaga(action) {
  try {
    const response = yield call(FetchEpgList, action.payload);
    if (response?.data?.success) {
      yield put(epgActions.FetchMoreEpgListSuccess(response?.data));
    } else {
      yield put(epgActions.FetchMoreEpgListFailed(response?.data?.message));
    }
  } catch (error) {
    yield put(epgActions.FetchMoreEpgListFailed(error));
  }
}

export function* addEpgChannelAddSaga(action) {
  try {
    const response = yield call(addEpgChannel, action.payload);
    if (response?.data?.success) {
      yield put(epgActions.addEpgChannelAddSuccess(response));
    } else {
      yield put(
        epgActions.addEpgChannelAddFailed(
          response?.data?.message || response?.message,
        ),
      );
    }
  } catch (error) {
    yield put(epgActions.addEpgChannelAddFailed(error));
  }
}

export function* updateEpgListItemSaga(action) {
  try {
    const response = yield call(updateEpgListItem, action.payload);
    if (response?.data?.success) {
      yield put(epgActions.updateEpgListItemSuccess(response));
    } else {
      yield put(epgActions.updateEpgListItemFailed(response?.data?.message));
    }
  } catch (error) {
    yield put(epgActions.updateEpgListItemFailed(error));
  }
}

export function* deleteEpgChannelSaga(action) {
  try {
    const response = yield call(deleteEpgChannel, action?.payload);
    if (response?.data?.success) {
      yield put(epgActions.DeleteEpgChannelSuccess(response));
    } else {
      yield put(
        epgActions.DeleteEpgChannelFailed(
          response?.data?.message || response?.message,
        ),
      );
    }
  } catch (error) {
    yield put(epgActions.DeleteEpgChannelFailed(error));
  }
}

export function* fetchEpgChangeLog() {
  try {
    const response = yield call(FetchEpgChangeLog);
    if (response?.data?.success) {
      yield put(epgActions.FetchEpgChangeLogSuccess(response?.data?.data));
    } else {
      yield put(epgActions.FetchEpgChangeLogFailed(response?.data?.message));
    }
  } catch (error) {
    yield put(epgActions.FetchEpgChangeLogFailed(error));
  }
}

export function* epgEnrichmentWatcher() {
  yield all([takeLatest(epgActions.types.FETCH_EPG_LIST, fetchEpgListSaga)]);
  yield all([
    takeLatest(epgActions.types.FETCH_MORE_EPG_LIST, fetchMoreEpgListSaga),
  ]);
  yield all([
    takeLatest(epgActions.types.EPG_CHANNEL_ADD, addEpgChannelAddSaga),
  ]);
  yield all([
    takeLatest(epgActions.types.UPDATE_EPG_LIST_ITEM, updateEpgListItemSaga),
  ]);
  yield all([
    takeLatest(epgActions.types.DELETE_EPG_CHANNEL, deleteEpgChannelSaga),
  ]);
  yield all([
    takeLatest(
      epgActions.types.FETCH_EPG_CHANNEL_CHANGE_LOG,
      fetchEpgChangeLog,
    ),
  ]);
}
